import dashboardBundleService from '@/services/dashboard/event_dashboard_bundle'
import useDateFormatter from '@/composables/useDateFormatter'

const { normalizeDate, formatDateTime } = useDateFormatter()

function mapActivity(guest) {
  const status = Number(guest.is_confirm || 0)
  const fullName = `${guest.name || ''} ${guest.last_name || ''}`.trim() || 'Invitado'
  const dateValue = guest.confirm_date || ''

  if (status === 1) {
    return {
      icon: 'cil-check-circle',
      color: 'success',
      date: dateValue,
      dateText: formatDateTime(dateValue),
      description: `${fullName} confirmo asistencia.`
    }
  }

  if (status === 2) {
    return {
      icon: 'cil-x-circle',
      color: 'danger',
      date: dateValue,
      dateText: formatDateTime(dateValue),
      description: `${fullName} cancelo asistencia.`
    }
  }

  if (status === 3) {
    return {
      icon: 'cil-warning',
      color: 'warning',
      date: dateValue,
      dateText: formatDateTime(dateValue),
      description: `${fullName} dejo una confirmacion incompleta.`
    }
  }

  return null
}

export default {
  async get(eventId, options = {}) {
    if (!eventId) {
      return []
    }

    try {
      const bundle = await dashboardBundleService.get(eventId, options)
      const serverActivity = bundle.recentActivity || []

      if (serverActivity.length) {
        return serverActivity
          .map(mapActivity)
          .filter(activity => !!activity && !!activity.date)
          .sort((a, b) => {
            const aDate = normalizeDate(a.date)
            const bDate = normalizeDate(b.date)
            const aTime = aDate ? aDate.getTime() : 0
            const bTime = bDate ? bDate.getTime() : 0
            return bTime - aTime
          })
          .slice(0, 8)
      }

      const guests = bundle.guests || []

      return guests
        .map(mapActivity)
        .filter(activity => !!activity && !!activity.date)
        .sort((a, b) => {
          const aDate = normalizeDate(a.date)
          const bDate = normalizeDate(b.date)
          const aTime = aDate ? aDate.getTime() : 0
          const bTime = bDate ? bDate.getTime() : 0
          return bTime - aTime
        })
        .slice(0, 8)
    } catch (error) {
      return []
    }
  },

  invalidate(eventId) {
    dashboardBundleService.invalidate(eventId)
  }
}
